// extracted by mini-css-extract-plugin
export default {"clModal":"login_clModal__i6P9V","clBoxLogout":"login_clBoxLogout__hvjRY"};